import { Injectable } from '@angular/core';
import { HttpRequest, HttpHandler, HttpEvent, HttpInterceptor, HttpErrorResponse } from '@angular/common/http';
import { Observable, throwError } from 'rxjs';
import { catchError } from 'rxjs/operators';
import Swal from 'sweetalert2';
import { UserService } from '../../app/shared/services/user.service';
import { Router } from '@angular/router';
import { AuthService } from '../../app/shared//services/auth.service';
import { environment } from 'src/environments/environment';
@Injectable()
export class ErrorInterceptor implements HttpInterceptor {
    constructor(private authService: AuthService, private userService: UserService, private router: Router) { }

    intercept(request: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<any>> {
      return next.handle(request).pipe(catchError(err => {
          switch(err.status){
              case 401:{
                  // auto logout if 401 response returned from api
                  if(this.router.url !== "/lock-screen"){
                      this.authService.logout();
                  }
                  if(err.url !== `${environment.apiURL}/api/account/login`){
                      location.reload();
                  }
                  break;
              }
              case 403:{
                  this.router.navigate(['/']);
              }
              
          }
          return throwError(err);
      }));
  }
    //new interceptor
    // intercept(req: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<any>> {
    //     return next.handle(req).pipe(
    //       catchError((error: HttpErrorResponse) => {
    //         let errorMessage = 'An unknown error occurred!';
            
    //         if (error.error instanceof ErrorEvent) {
    //           // Client-side or network error
    //           errorMessage = `Client-side error: ${error.error.message}`;
    //         } else {
    //           // Backend error
    //           if (error.status === 0) {
    //             errorMessage = 'Unable to connect to the server. Please try again later.';
    //           } else if (error.error && error.error.message) {
    //             errorMessage = error.error.message; // Backend error message
    //           } else {
    //             errorMessage = `Server error (Code: ${error.status})`;
    //           }
    //         }
    
    //         // Show error message (e.g., using SweetAlert or any notification service)
    //         Swal.fire({
    //           title: 'Error',
    //           text: errorMessage,
    //           icon: 'error',
    //           confirmButtonText: 'OK',
    //         });
    
    //         // Log the error (optional)
    //         console.error('Error from interceptor:', error);
    
    //         // Pass the error to the caller
    //         return throwError(() => new Error(errorMessage));
    //       })
    //     );
    //   }
}
